import axios from "axios";
import React, { useEffect, useState } from "react";
import mainBg from "../assets/images/personal-bg.svg"; // Import the background image
import Close from "../assets/images/X.svg"; // Import the background image
import Spinner from "./Spinner";

export default function Companies({ getTourId, closeCodeModal }) {
  const [responseData, setResponseData] = useState();
  const [tempHtml, setTempHtml] = useState();
  const [loading, setLoading] = useState(true); // State to track loading status
  const [noCompanies, setNoCompanies] = useState(false); // State to track loading status

  useEffect(() => {
    const getCompanies = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_ECOMMERCE_BASE_URL}/api/v1/ecomm_products?kind=4`,
          {
            headers: {
              apikey: "5f28583f26a1a",
              lang: "en",
              apiconnection: "appmobile",
              "secure-business-key": process.env.REACT_APP_BUSINESS_KEY,
            },
          }
        );

        if (response?.data.status === true) {
          setResponseData(response?.data.data.data); // This sets the state
          setLoading(false); // Data has been fetched, stop the loader
          setNoCompanies(false);
        }
      } catch (error) {
        // Handle any errors
        setNoCompanies(true);
        setLoading(false); // Stop the loader if there's an error
      }
    };

    getCompanies();
  }, []); // Runs only once when the component mounts

  // Log tempHtml whenever it changes
  useEffect(() => {
    const obj = responseData?.find((item) => {
      return item?.id == getTourId;
    });

    if (obj) {
      setTempHtml(obj.descriptions[0].content);
    } else {
    }
  }, [responseData]); // This effect runs when responseData is updated

  return (
    <div className="leap-overflow-auto leap-relative leap-w-full leap-h-[80vh]">
      {loading ? ( // If loading, show a loader
        <div className="leap-h-full leap-flex leap-flex-col leap-items-center leap-justify-center">
          <Spinner />
        </div>
      ) : (
        <>
          {/* 
<h1 className="custom-white-border md:leap-mb-16 leap-text-[30px] sm:leap-text-[45px] leap-my-3 leap-font-bold leap-text-center leap-uppercase leap-text-white">
                No Companies Found
              </h1> */}

          <div
            className="leap-pt-[10vh] max-h-[80vh] leap-overflow-auto leap-w-full"
            // style={{
            //   backgroundImage: `url(${mainBg})`, // Set the background image
            //   backgroundSize: "cover", // Ensures the image covers the full container
            // }}
            dangerouslySetInnerHTML={{
              __html: tempHtml || (
                <p className="leap-bg-red-500">No Companies Found</p>
              ),
            }}
          ></div>

          <button className="" onClick={closeCodeModal}>
            <img
              src={Close}
              alt="Close"
              className="leap-absolute leap-top-[20px] leap-left-[10px] leap-w-10 leap-h-10 sm:leap-w-8 sm:leap-h-8 md:leap-w-10 md:leap-h-10 lg:leap-w-14 lg:leap-h-14"
            />
          </button>
        </>
      )}
    </div>
  );
}
